module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'o3sbc3dq',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
